import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ConfirmDialogModel } from '../../../core/_models/confirm-dialog.model';

@Component({
  selector: 'app-confirm',
  templateUrl: './confirm.component.html',
  styleUrls: ['./confirm.component.scss'],
})
export class ConfirmComponent {
  imgUrl: string = 'warning';
  constructor(@Inject(MAT_DIALOG_DATA) public data: ConfirmDialogModel) {
    if (this.imgUrl) {
      if (data?.imgUrl) this.imgUrl = data?.imgUrl
    }
  }

  formatMessage(message: string): string {
    return message.replace(/\n/g, '<br/>');
  }
}
